import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import { TableBody, TableCell, TableRow } from '@material-ui/core';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import usageTypes from '../../constants/UsageType';
import CancelButton from '../../components/atoms/CancelButton';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    padding: 20,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    color: '#000000'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  titleDetail: {
    margin: '20px 0px 24px',
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 24,
    fontWeight: 700,
    color: '#000000'
  },
  btnBtom: {
    padding: '38px 0 20px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction,
    editConfirm,
    usageTypeName,
    reducedTaxMenuPrefix,
    taxTypes,
    menuGenreName,
    previewImage
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;

    return (
      <div className={classes.root}>
        <Typography className={classes.titleDetail}>
          メニュー編集の確認
        </Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>用途</TableCell>
                <TableCell className={classes.tableCellData}>
                  {usageTypeName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>店舗名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.shopName}
                </TableCell>
              </TableRow>
              {editConfirm.usageType === USAGE_TYPE_MENU && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(() => {
                        if (editConfirm.reducedTaxType === 'REDUCED') {
                          return reducedTaxMenuPrefix;
                        }
                        return '';
                      })()}
                      {editConfirm.menuName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー画像
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      <ImagePreview previewImage={previewImage} />
                    </TableCell>
                  </TableRow>
                </>
              )}
              {editConfirm.usageType === USAGE_TYPE_COMBO ? (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    単価×発行枚数
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {`${parseInt(
                      editConfirm.priceCombo,
                      10
                    ).toLocaleString()}円ｘ${editConfirm.quantityRelease}枚`}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>価格</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {parseInt(editConfirm.price, 10).toLocaleString()}
                    {`円`}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>税区分</TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.taxType &&
                  editConfirm.taxType.toString() === 'DONATION'
                    ? taxTypes.map(item => {
                        if (item.id.toString() === 'INTERNAL') {
                          return item.name;
                        }
                        return '';
                      })
                    : taxTypes.map(item => {
                        if (
                          editConfirm.taxType &&
                          editConfirm.taxType.toString() === item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  軽減税率対象
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {(() => {
                    if (editConfirm.reducedTaxType === 'REDUCED') {
                      return '対象';
                    }
                    return '対象外';
                  })()}
                </TableCell>
              </TableRow>
              {editConfirm.usageType === USAGE_TYPE_COMBO && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      付与無料枚数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.quantityPromotion
                        ? `${editConfirm.quantityPromotion}枚`
                        : ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      おまけ
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.promotionDescription}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  ジャンル
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {menuGenreName}
                </TableCell>
              </TableRow>
              {editConfirm.usageType === USAGE_TYPE_MENU && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>説明</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.description}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>タグ</TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.tagStr}
                </TableCell>
              </TableRow>
              {editConfirm.usageType !== USAGE_TYPE_MENU && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(() => {
                        if (editConfirm.reducedTaxType === 'REDUCED') {
                          return reducedTaxMenuPrefix;
                        }
                        return '';
                      })()}
                      {editConfirm.menuName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー画像
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      <ImagePreview previewImage={previewImage} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      説明
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.description}
                    </TableCell>
                  </TableRow>
                </>
              )}
              {editConfirm.usageType === USAGE_TYPE_COMBO && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {(() => {
                      if (editConfirm.numberUsePerDay === 0) {
                        return 'なし';
                      }
                      return '1日1枚';
                    })()}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用期間
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.expiration && editConfirm.expiration !== ''
                    ? `${editConfirm.expiration}日間`
                    : editConfirm.expirationEndDate}
                </TableCell>
              </TableRow>
              {editConfirm.usageType === USAGE_TYPE_VOUCHER && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用方法
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.menuLimitTotal === 1
                      ? '一円単位利用'
                      : '一枚単位利用'}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  寄付設定
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.taxType === 'DONATION' ? '対象内' : '対象外'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div className={classes.btnBtom}>
          <CancelButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
